import { Box, PaletteMode, Typography } from '@mui/material';
import { useContext } from 'react';
import PaletteModeContext from '../../contexts/PaletteModeContext';
import AlternativeLogo from './pngs/s3g-logo-alternative.png';
import MainLogo from './pngs/s3g-logo-main.png';

/**
 * The logo properties
 */
interface LogoProps {
  /**
   * The size of the logo. This adjusts the height using 'em' and then dynamically adjusts the width to keep the expected
   *   aspect ratio for the logo
   */
  sizeEm: number;
  /**
   * Whether to show the text with the logo
   * @default false
   */
  showText?: boolean;

  /**
   * Where the text should be positioned
   * @default 'right'
   */
  textPosition?: 'right' | 'below';

  /**
   * Lock the color to a theme. If unset, the color will dynamically change.
   */
  theme?: PaletteMode | null;
}

/**
 * A component that shows the S3G Security logo
 */
const Logo = ({
  sizeEm,
  showText = false,
  textPosition = 'right',
  theme = null,
}: LogoProps) => {
  const paletteMode = useContext(PaletteModeContext);
  const logoBoxId = 'logo-box-id';

  return (
    <Box
      id={logoBoxId}
      display="inline-flex"
      flexDirection={textPosition == 'right' ? 'row' : 'column'}
      alignItems="center"
    >
      <Box
        sx={{
          height: `${sizeEm}em`,
          aspectRatio: '1/1',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          backgroundImage: `url(${
            theme ?? paletteMode == 'light' ? MainLogo : AlternativeLogo
          })`,
          marginRight:
            showText && textPosition == 'right' ? `${sizeEm * 0.5}em` : 0,
        }}
      />
      <Typography
        display={showText ? 'initial' : 'none'}
        variant="h1"
        fontSize={`${sizeEm * (textPosition == 'right' ? 0.7 : 0.3)}em`}
        fontWeight="500"
        noWrap
      >
        S3G Security
      </Typography>
    </Box>
  );
};

export default Logo;
